<template>
  <div v-if="!loading && selectedImage" class="full-screen-image">
    <v-img 
      lazy-src="https://media.istockphoto.com/videos/loading-circle-icon-animation-on-white-background-4k-video-loopable-video-id1302436594?s=640x640" :src="selectedImage.url" >
      <template v-slot:placeholder>
        <v-layout
          fill-height
          align-center
          justify-center
          ma-0
        >
          <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
        </v-layout>
      </template>
    </v-img>
  </div>
</template>
<script>
import masjidImageService from '@/modules/MasjidImage/Ad/service.js'
export default {
  data() {
    return {
      adImages: [],
      interval: null,
      selectedImage: null,
      count: 0,
      code: null,
      loading: false
    }
  },
  async created() {
    await this.getImages()
    this.interval = setInterval(() => {
      this.setImage();
    }, 15000);
  },
  beforeDestroy(){
    clearInterval(this.interval);
  },
  methods: {
    getImages(){
      this.loading = true
      this.code = this.$route.params.code
      masjidImageService.getAllPublicImages({code: this.code}).then((response) => {
        console.log('response', response)
        this.adImages = response.data
        this.selectedImage = this.adImages[0];
        this.count++
        if(!response.data.length){
            this.$router.push({ name: "pagenotfound" });
          }
        this.loading = false
      })
      .catch((error) => {
          console.log("error getting images", error);
          this.$router.push({ name: "pagenotfound" });
        });
    },
    setImage(){
      if(this.count >= this.adImages.length){
        this.count = 0
      }
      this.selectedImage = this.adImages[this.count]
      this.count++
    }
  }
}
</script>
<style scoped>
.full-screen-image {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8); /* Optional overlay background color */
  display: flex;
  justify-content: center;
  align-items: center;
}

.full-screen-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain; /* Adjust as needed to control how the image fits within the screen */
}
</style>